module.exports = __webpack_public_path__ + "static/Veteran-28d692df37d78e270c915b9cf59618db.png";